import React from 'react'
import { SvgIcon as Icon } from '@material-ui/core'

const SubgroupsIcon = ({ ...props }) => {
  return (
    <Icon {...props}>
      <g className="outline">
        <path
          fillRule="evenodd"
          d="M9 4.5C7.61929 4.5 6.5 5.61929 6.5 7C6.5 8.38071 7.61929 9.5 9 9.5C10.3807 9.5 11.5 8.38071 11.5 7C11.5 5.61929 10.3807 4.5 9 4.5ZM5.5 7C5.5 5.067 7.067 3.5 9 3.5C10.933 3.5 12.5 5.067 12.5 7C12.5 8.933 10.933 10.5 9 10.5C7.067 10.5 5.5 8.933 5.5 7Z"
        />
        <path
          fillRule="evenodd"
          d="M14.5 4C14.5 3.72386 14.7239 3.5 15 3.5C16.933 3.5 18.5 5.067 18.5 7C18.5 8.933 16.933 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10C14.5 9.72386 14.7239 9.5 15 9.5C16.3807 9.5 17.5 8.38071 17.5 7C17.5 5.61929 16.3807 4.5 15 4.5C14.7239 4.5 14.5 4.27614 14.5 4Z"
        />
        <path
          fillRule="evenodd"
          d="M12 13H6C4.34315 13 3 14.3431 3 16V18H15V16C15 14.3431 13.6569 13 12 13ZM6 12C3.79086 12 2 13.7909 2 16V18C2 18.5523 2.44772 19 3 19H15C15.5523 19 16 18.5523 16 18V16C16 13.7909 14.2091 12 12 12H6Z"
        />
        <path
          fillRule="evenodd"
          d="M17.5 12.5C17.5 12.2239 17.7239 12 18 12C18.5645 12 19.559 12.138 20.425 12.7875C21.3179 13.4572 22 14.6152 22 16.5V18C22 18.2761 21.7761 18.5 21.5 18.5C21.2239 18.5 21 18.2761 21 18V16.5003C21 14.8851 20.4321 14.0428 19.825 13.5875C19.191 13.112 18.4355 13 18 13C17.7239 13 17.5 12.7761 17.5 12.5Z"
        />
      </g>
      <g className="filled">
        <path d="M9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10Z" />
        <path
          fillRule="evenodd"
          d="M9 4.5C7.61929 4.5 6.5 5.61929 6.5 7C6.5 8.38071 7.61929 9.5 9 9.5C10.3807 9.5 11.5 8.38071 11.5 7C11.5 5.61929 10.3807 4.5 9 4.5ZM5.5 7C5.5 5.067 7.067 3.5 9 3.5C10.933 3.5 12.5 5.067 12.5 7C12.5 8.933 10.933 10.5 9 10.5C7.067 10.5 5.5 8.933 5.5 7Z"
        />
        <path
          fillRule="evenodd"
          d="M14.5 4C14.5 3.72386 14.7239 3.5 15 3.5C16.933 3.5 18.5 5.067 18.5 7C18.5 8.933 16.933 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10C14.5 9.72386 14.7239 9.5 15 9.5C16.3807 9.5 17.5 8.38071 17.5 7C17.5 5.61929 16.3807 4.5 15 4.5C14.7239 4.5 14.5 4.27614 14.5 4Z"
        />
        <path d="M2 16C2 13.7909 3.79086 12 6 12H12C14.2091 12 16 13.7909 16 16V18C16 18.5523 15.5523 19 15 19H3C2.44772 19 2 18.5523 2 18V16Z" />
        <path
          fillRule="evenodd"
          d="M12 13H6C4.34315 13 3 14.3431 3 16V18H15V16C15 14.3431 13.6569 13 12 13ZM6 12C3.79086 12 2 13.7909 2 16V18C2 18.5523 2.44772 19 3 19H15C15.5523 19 16 18.5523 16 18V16C16 13.7909 14.2091 12 12 12H6Z"
        />
        <path
          fillRule="evenodd"
          d="M17.5 12.5C17.5 12.2239 17.7239 12 18 12C18.5645 12 19.559 12.138 20.425 12.7875C21.3179 13.4572 22 14.6152 22 16.5V18C22 18.2761 21.7761 18.5 21.5 18.5C21.2239 18.5 21 18.2761 21 18V16.5C21 14.8848 20.4321 14.0428 19.825 13.5875C19.191 13.112 18.4355 13 18 13C17.7239 13 17.5 12.7761 17.5 12.5Z"
        />
      </g>
    </Icon>
  )
}

export default SubgroupsIcon
